import { styled } from "styled-components";
import { DragDrop } from "awantunai-design-system";
interface UploadProps {
    onChange: (url: string) => void;
    url?: string;
    label: string;
    helpText?: string;
    types?: string[];
    uploading?: boolean;
    style?: any;
}

const UploadFilePicker = ({
    url,
    label,
    helpText,
    onChange,
    uploading,
    types,
    style
}: UploadProps) => {
    return (
        <Container>
            <DragDrop
                helpText={helpText}
                label={label}
                maxSize={5}
                minSize={0}
                onChange={(file: any) => {
                    onChange(file);
                }}
                value={url}
                placeholder="Drag & drop a video here"
                types={types}
                style={style}
                loading={uploading}
            />
        </Container>
    )
}

export default UploadFilePicker;

const Container = styled.div`
    display: inline-block;
    margin: 10px;
`;